import React, { FC } from 'react'

import { GenericFeedbackPage } from 'components'

import { usePrivacyPolicyAcceptanceSuccess } from '../hooks/usePrivacyPolicyAcceptanceSuccess'

export const PrivacyPolicyAcceptanceSuccess: FC = () => {
  const { icon, iconColor, title, details, confirmButtonText, loading, confirmButtonClickHandler } =
    usePrivacyPolicyAcceptanceSuccess()

  return (
    <GenericFeedbackPage
      loading={loading}
      title={title}
      details={details}
      icon={icon}
      iconColor={iconColor}
      confirmButton={{
        text: confirmButtonText,
        onClick: confirmButtonClickHandler,
      }}
    />
  )
}
